import { createContext, useContext } from "react";

export const StoreSettingsContext = createContext({
  storeSettings: [],
  fetchStoreSettings: () => {},
  reloadStoreSettings: () => {},
  HideStoreSettingsSkeleton: false,
  isUpdatedStoreSettings: false,
  StoreSettingsError: null,
  removeStoreSettings: () => {},
  setHideStoreSettingsSkeleton: () => {},
  settingsStoreUsername: '',
});

export const useStoreSettingsContext = () => useContext(StoreSettingsContext);
